import React, { useEffect, useRef, useState } from 'react';
import '../../../Static/priceinfo.css';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery, Button } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Paper } from '@mui/material';
import ReactToPrint from 'react-to-print';

import FirmHeaderImg from '../../FieldsComponents/FirmHeaderImg';
import { fetchMaterialPIReg } from '../../../Store/PHPSlice/Purchase/PoNo';
import { selectMaterialPIReg } from '../../Selectors/Master/OutwardSelectors';


const MaterialPIView = () => {
    const { Id } = useParams();
    const [formData, setFormData] = useState({});
    const dispatch = useDispatch();
    const polist = useSelector(selectMaterialPIReg);
    const isDesktop = useMediaQuery('(min-width:768px)');
    const componentRef = useRef();
    useEffect(() => {
        dispatch(fetchMaterialPIReg(Id))
    }, [Id, dispatch]);

    useEffect(() => {
        if (polist?.data) {
            setFormData(polist?.data);
        }
    }, [polist]);

    // console.log(polist);
    const tableContainerStyle = {
        marginLeft: isDesktop ? '0%' : '0%',
        width: isDesktop ? '90%' : '100%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',  // Ensure the x-axis scrollbar is visible
        overflowY: 'hidden', // Hide the y-axis scrollbar
        WebkitOverflowScrolling: 'touch', // Enable smooth scrolling on iOS
    };
    // console.log(polist)

    return (
        <>
            <Grid item xs={12}>
                <Paper style={{ padding: '3vh', margin: '0' }}>
                    <div style={{ width: '100%' }} ref={componentRef}>
                        {formData?.firmId !== '' && <FirmHeaderImg firmId={formData.firmId} />}
                        <h3 className='centered-heading'>Material Purchase Order View</h3>
                        <div className="dashed-line"></div>

                        <table style={{ fontSize: '15px' }}>

                            <tbody>
                                <tr>
                                    <td style={{ width: '200px' }}>Date</td>

                                    <td style={{ width: '30vw', padding: '0.2% 1.5%' }} className='light-color'>{formData.date}</td>
                                    <td style={{ width: '200px', paddingLeft: '2%' }}>PI No.</td>

                                    <td style={{ padding: '0.2% 1%', width: '150px' }} className='dark-color'>{formData.piNo}</td>
                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>Party</td>

                                    <td style={{ width: '25vw', padding: '0.2% 1.5%' }} className='light-color'>{formData.partyNm}</td>
                                    <td style={{ width: '200px', paddingLeft: '2%' }}>PO No.</td>

                                    <td style={{ padding: '0.2% 1%', width: '150px' }} className='dark-color'>{formData.pono}</td>
                                    {/* <td style={{ width: '200px' }}>Firm</td>

                                    <td style={{ width: '25vw', padding: '0 1.5%' }} className='light-color'>{formData.firmNm}</td> */}
                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>Total Mtr</td>

                                    <td style={{ padding: '0.2% 1.5%' }}>{formData.totmtr}</td>
                                    <td style={{ width: '200px' }}>Bill No.</td>

                                    <td style={{ padding: '0.2% 1.5%' }}>{formData.billno}</td>
                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>Total Qty</td>

                                    <td style={{ padding: '0.2% 1.5%' }}>{formData.totqty}</td>
                                    <td style={{ width: '200px' }}>Amount</td>

                                    <td style={{ padding: '0.2% 1.5%' }}>{formData.totamt}</td>
                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>Tax Amount</td>

                                    <td style={{ padding: '0.2% 1.5%' }}>{formData.taxamt}</td>
                                    <td style={{ width: '200px' }}>Final Amount</td>

                                    <td style={{ padding: '0.2% 1.5%' }}>{formData.finalamt}</td>
                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>LR Date</td>

                                    <td style={{ padding: '0.2% 1.5%' }}>{formData.lrdt}</td>
                                    <td style={{ width: '200px' }}>LR No.</td>

                                    <td style={{ padding: '0.2% 1.5%' }}>{formData.lrno}</td>
                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>Transport</td>

                                    <td style={{ padding: '0.2% 1.5%' }}>{formData.transportNm}</td>
                                    <td style={{ width: '200px' }}>Location</td>

                                    <td style={{ padding: '0.2% 1.5%' }}>{formData.locNm}</td>
                                </tr>

                            </tbody>
                        </table>


                        <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell className='th4' sx={{ p: 0.2, border: '1px solid #000' }} align='center'>Sr.No.</TableCell>
                                        <TableCell className='th4' sx={{ p: 0.2, border: '1px solid #000' }} align='center'>Barcode</TableCell>
                                        <TableCell className='th4' sx={{ p: 0.2, border: '1px solid #000' }} align='center'>Material</TableCell>
                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>M.Qty & Type</TableCell>
                                        <TableCell className='th4' sx={{ p: 0.2, border: '1px solid #000' }} align='center'>P.P Qty/Mtr & Type</TableCell>
                                        <TableCell className='th4' sx={{ p: 0.2, border: '1px solid #000' }} align='center'>Rate</TableCell>
                                        <TableCell className='th4' sx={{ p: 0.2, border: '1px solid #000' }} align='center'>Qty</TableCell>
                                        <TableCell className='th4' sx={{ p: 0.2, border: '1px solid #000' }} align='center'>Mtr</TableCell>
                                        <TableCell className='th4' sx={{ p: 0.2, border: '1px solid #000' }} align='center'>Inches</TableCell>
                                        <TableCell className='th4' sx={{ p: 0.2, border: '1px solid #000' }} align='center'>Total Qty.</TableCell>
                                        <TableCell className='th4' sx={{ p: 0.2, border: '1px solid #000' }} align='center'>Amount</TableCell>
                                        {/* <TableCell className='th4' sx={{ p: 0.2, border: '1px solid #000' }} align='center'>IGST(%)</TableCell> */}
                                        <TableCell className='th4' sx={{ p: 0.2, border: '1px solid #000' }} align='center'>IGSTAmt</TableCell>
                                        {/* <TableCell className='th4' sx={{ p: 0.2, border: '1px solid #000' }} align='center'>CGST(%)</TableCell> */}
                                        <TableCell className='th4' sx={{ p: 0.2, border: '1px solid #000' }} align='center'>CGSTAmt</TableCell>
                                        {/* <TableCell className='th4' sx={{ p: 0.2, border: '1px solid #000' }} align='center'>SGST(%)</TableCell> */}
                                        <TableCell className='th4' sx={{ p: 0.2, border: '1px solid #000' }} align='center'>SGSTAmt</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {polist?.info?.map((row, index) => (
                                        <TableRow key={index}>

                                            <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>
                                                {index + 1}
                                            </TableCell>
                                            <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>
                                                {row.barcode}
                                            </TableCell>
                                            <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>
                                                {row.materialNm}
                                                <br />
                                                {`Size : ${row.size}`}
                                                <br />
                                                {`Hsn : ${row.hsn}`}
                                            </TableCell>
                                            <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>
                                                {row.pktqty}{" "}{row.mtype}
                                            </TableCell>
                                            <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>
                                                {row.perpacket}{" "}{row.ptype}
                                            </TableCell>
                                            <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>
                                                {row.rate}
                                            </TableCell>
                                            <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>
                                                {row.inwqty}
                                            </TableCell>
                                            <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>
                                                {row.inwmtr}
                                            </TableCell>
                                            <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>
                                                {row.inwInches}
                                            </TableCell>
                                            <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>
                                                {row.inwtotqty}
                                            </TableCell>
                                            <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>
                                                {row.amt}
                                            </TableCell>
                                            {/* <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>
                                                                        {row.igst}
                                                                    </TableCell> */}
                                            <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>
                                                {row.igstamt}{" "}{`(${row.igst}%)`}
                                            </TableCell>
                                            {/* <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>
                                                                        {row.cgst}
                                                                    </TableCell> */}
                                            <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>
                                                {row.cgstamt}{" "}{`(${row.cgst}%)`}
                                            </TableCell>
                                            {/* <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>
                                                                        {row.sgst}
                                                                    </TableCell> */}
                                            <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>
                                                {row.sgstamt}{" "}{`(${row.sgst}%)`}
                                            </TableCell>

                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>



                    </div>
                    <div style={{ margin: '2% 5%', paddingBottom: '2%' }}>
                        <ReactToPrint
                            trigger={() => <Button variant="contained" color="primary">Print</Button>}
                            content={() => componentRef.current}
                        />
                    </div>

                </Paper>
            </Grid>
        </>
    );
};

export default MaterialPIView;
